/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {FlagSt} from 'hiya-common/src/components/HiyaForm/components/VerifyPhone/service'
import {useSelector} from 'react-redux'

export enum Range {
  RangeToday = 1, // 1今天
  RangeDailyWeek = 2, // 2本周按天
  RangeDailyFourWeek = 3, // 3最近四周按天
  RangeWeeklyFourWeek = 4, // 4最近四周按周
  RangeDailyLastWeek = 5, // 5上周按天
}

export enum UnionChange {
  UnionInfoLogTypeCountry = 1,
  UnionInfoLogTypeRemark = 2,
  UnionInfoLogTypeName = 3,
  UnionInfoLogTypeLeader = 4,
  UnionInfoLogTypeContact = 5,
  UnionInfoLogTypeOperator = 6,
  UnionInfoLogTypeLocal = 7,
  UnionInfoLogTypeAvatar = 8,
  UnionInfoLogTypeSign = 9,
}

// 1:运营手动，2:运营邀请，3:BD邀请
export enum CreaType {
  运营手动 = 1,
  运营邀请 = 2,
  BD邀请 = 3,
}

export enum Type {
  Income = 1, // 1 收入
  People = 2, // 2 人数
}

export enum IncomeEnum {
  全部 = 'pearl',
  聊天 = 'im_pearl',
  礼物 = 'gift_pearl',
  语音通话 = 'voice_pearl',
  退款 = 'refund_and_recharge_pearl',
  其他 = 'other_pearl',
}

export enum PeopleEnum {
  全部 = 'total_users',
  有收入 = 'users_with_income',
  无收入 = 'users_without_income',
}

// 获取政策列表  http://wiki.xunlei.cn/pages/viewpage.action?pageId=161249579
export const get_settle_policy_list = createAsyncThunk(
  'Saada/saadaUnionCenter/get_settle_policy_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_settle_policy_list',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取公会收入总览 http://wiki.xunlei.cn/pages/viewpage.action?pageId=161249582
export const get_union_income_overview = createAsyncThunk(
  'Saada/saadaUnionCenter/get_union_income_overview',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_union_income_overview',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取公会信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=161249599
export const get_union_info = createAsyncThunk(
  'Saada/saadaUnionCenter/get_union_info',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_union_info',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

//  公会长收入 统计列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=161249584
export const get_statistical_owner_income_list = createAsyncThunk(
  'Saada/saadaUnionCenter/get_statistical_owner_income_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_statistical_owner_income_list',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

//  主播收入 统计列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=161249588
export const get_statistical_anchor_income_list = createAsyncThunk(
  'Saada/saadaUnionCenter/get_statistical_anchor_income_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_statistical_anchor_income_list',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主播人数 统计列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=161249591
export const get_statistical_anchor_count_list = createAsyncThunk(
  'Saada/saadaUnionCenter/get_statistical_anchor_count_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_statistical_anchor_count_list',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 收入下降预警卡快照
export const get_union_warning_snapshot = createAsyncThunk(
  'Saada/saadaUnionCenter/get_union_warning_snapshot',
  async (p: any, store: any): Promise<UnionWarningSnapshotDTO> => {
    const resp = await http.post(
      '/live/hiya_socialize/union_warning_snapshot',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const union_anchor_remind = createAsyncThunk(
  'Saada/saadaUnionCenter/union_anchor_remind',
  async (
    p: {
      filter: 1 | 2
      source: number
      snapshot_id?: number
    },
    store: any
  ): Promise<UnionAnchorRemindDTO> => {
    const resp = await http.post(
      '/live/hiya_socialize/union_anchor_remind',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 更新 公会信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=161249601
export const update_union_info = createAsyncThunk(
  'Saada/saadaUnionCenter/update_union_info',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/update_union_info',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface PolicyDTO {
  level: number // 等级
  anchor_pearl: number // 主播珍珠
  union_pearl: number // 公会珍珠
}

export interface UnionWarningSnapshotDTO {
  err_msg: string
  snapshot_id: number
  show: boolean
  unauth_anchor_count: number
  inactive_anchor_count: number
  unauth_estimated_loss_usd: string
  inactive_estimated_loss_usd: string
  unauth_handled: boolean
  inactive_handled: boolean
}

export interface UnionAnchorRemindDTO {
  err_msg: string
  sent_count: number
  push_count: number
  disabled: boolean
  toast: string
}

const initialState: {
  policy_list?: PolicyDTO[]
  cur_level?: number
  cur_period_st?: string // 当前周期开始时间
  cur_period_et?: string // 当前周期结束时间
  change_owner_times?: number // 换了几次公会长了
  cur_owner_pearl_pearl?: number // 当前公会长收入
  pre_owner_pearl_pearl?: number // 前公会长收入
  total_anchor_pearl?: number // 总主播收入
  today_anchor_pearl?: number // 今天主播收入
  next_level_require_anchor_pearl?: number // 下一等级需要主播珍珠数量
  next_level_reward_union_pearl?: number // 下一等级奖励公会珍珠数量
  union_total?: {
    list?: {
      pearl_list: {mid: number; pearl: number; is_cur_owner: boolean}[]
      date_pearl: number
      date: string
    }[]
  } // 公会统计列表
  anchor_total?: {
    type: Type
    list?: {
      // 收入
      pearl?: number
      gift_pearl?: number
      im_pearl?: number
      voice_pearl?: number
      refund_and_recharge_pearl?: number
      other_pearl?: number
      // 人数
      total_users?: number
      users_with_income?: number // 有收入人数
      users_without_income?: number // 无收入人数
      date: string
    }[]
  } // 主播统计列表
  union_info?: {
    union_id?: number // 公会信息
    name?: string // 公会名称
    mid?: number // 公会长mid
    sign?: string // 公会介绍
    flag?: FlagSt // 公会国家国旗
    avatar?: string // 公会头像
    register_info?: {
      union_create_method?: CreaType
      first_owner_mid?: number
      ct?: string
      contact_app?: string
      contact_account?: string
    }
    could_update_avatar_times: number
    could_update_sign_times: number
    delete_anchor_red_dot: number
    refund_red_dot: boolean
  } // 公会信息
  union_warning_snapshot?: UnionWarningSnapshotDTO // 收入下降预警快照
} = {}
// {
//   // mock
//   policy_list: [
//     {level: 1, anchor_pearl: 20, union_pearl: 10},
//     {level: 2, anchor_pearl: 20, union_pearl: 10},
//     {level: 3, anchor_pearl: 20, union_pearl: 10},
//     {level: 4, anchor_pearl: 20, union_pearl: 10},
//     {level: 5, anchor_pearl: 80, union_pearl: 40},
//     {level: 6, anchor_pearl: 20, union_pearl: 10},
//     {level: 7, anchor_pearl: 20, union_pearl: 10},
//     {level: 8, anchor_pearl: 20, union_pearl: 10},
//     {level: 9, anchor_pearl: 20, union_pearl: 10},
//     {level: 10, anchor_pearl: 20, union_pearl: 10},
//     {level: 11, anchor_pearl: 20, union_pearl: 10},
//     {level: 12, anchor_pearl: 20, union_pearl: 10},
//     {level: 13, anchor_pearl: 900000000, union_pearl: 900000000},
//   ],
//   cur_level: 10,
//   cur_period_st: '2010-09-09 10:10',
//   cur_period_et: '2010-09-09 10:10',
//   change_owner_times: 0,
//   cur_owner_pearl_pearl: 100,
//   pre_owner_pearl_pearl: 100,
//   total_anchor_pearl: 10,
//   today_anchor_pearl: 100,
//   next_level_require_anchor_pearl: 10,
//   next_level_reward_union_pearl: 11,
//   union_total: {
//     list: [
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 1000,
//         date: '2025-04-21',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 500,
//         date: '2025-04-22',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 1600,
//         date: '2025-04-23',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-04-24',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-04-25',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-04-26',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-04-27',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-04-28',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-04-29',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-04-30',
//       },

//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 1000,
//         date: '2025-05-01',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 500,
//         date: '2025-05-02',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 1600,
//         date: '2025-05-03',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-04',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-05',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-06',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-07',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-08',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-09',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-10',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 500,
//         date: '2025-05-11',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 1600,
//         date: '2025-05-12',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-13',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-14',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-15',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-16',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-17',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-18',
//       },
//       {
//         pearl_list: [{mid: 11006153, pearl: 110, is_cur_owner: true}],
//         date_pearl: 100,
//         date: '2025-05-19',
//       },
//     ],
//   },
//   anchor_total: {
//     type: Type.Income,
//     list: [
//       {
//         pearl: 1000,
//         date: '2025-04-21',
//         gift_pearl: 100,
//         im_pearl: 200,
//         voice_pearl: 400,
//         refund_and_recharge_pearl: 500,
//         other_pearl: 1200,
//       },
//       {
//         pearl: 1000,
//         date: '2025-04-22',
//         gift_pearl: 100,
//         im_pearl: 200,
//         voice_pearl: 400,
//         refund_and_recharge_pearl: 500,
//         other_pearl: 1200,
//       },
//       {
//         pearl: 1000,
//         date: '2025-04-22',
//         gift_pearl: 100,
//         im_pearl: 200,
//         voice_pearl: 400,
//         refund_and_recharge_pearl: 500,
//         other_pearl: 1200,
//       },
//     ],
//   },
//   union_info: {
//     union_id: 12121,
//     name: 'kunkun union', // 公会名称
//     mid: 11006189, // 公会长mid
//     sign: 'niu niu is a good Boy !', // 公会介绍
//     flag: {
//       country: 'China',
//       url: '',
//       area_code: 0,
//       region_code: 0,
//     }, // 公会国家国旗
//     avatar: '', // 公会头像
//     register_info: {
//       union_create_method: CreaType.BD邀请,
//       first_owner_mid: 11008901,
//       ct: '2029-09-01 10:10',
//       contact_app: 'what apps',
//       contact_account: '112121',
//     },
//     could_update_avatar_times: 1,
//     could_update_sign_times: 1,
//   },
// }

export function useSaadaUnionCenter() {
  return useSelector((store) => store.Animal_Quokka)
}

export const SaadaUnionCenterSlice = createSlice({
  name: 'Animal_Quokka',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_settle_policy_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(get_union_income_overview.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(
      get_statistical_owner_income_list.fulfilled,
      (state, action) => {
        Object.assign(state, {union_total: action.payload})
      }
    )
    builder.addCase(
      get_statistical_anchor_income_list.fulfilled,
      (state, action) => {
        Object.assign(state, {
          anchor_total: {
            ...action.payload,
            type: Type.Income,
          },
        })
      }
    )
    builder.addCase(
      get_statistical_anchor_count_list.fulfilled,
      (state, action) => {
        Object.assign(state, {
          anchor_total: {
            ...action.payload,
            type: Type.People,
          },
        })
      }
    )
    builder.addCase(get_union_info.fulfilled, (state, action) => {
      Object.assign(state, {
        union_info: {
          ...action.payload,
        },
      })
    })
    builder.addCase(get_union_warning_snapshot.fulfilled, (state, action) => {
      Object.assign(state, {
        union_warning_snapshot: {
          ...action.payload,
        },
      })
    })
  },
})

export default SaadaUnionCenterSlice.reducer
export const SaadaUnionCenterActions = SaadaUnionCenterSlice.actions
